import { render, staticRenderFns } from "./details-news.vue?vue&type=template&id=36d51590&scoped=true"
import script from "./details-news.vue?vue&type=script&lang=js"
export * from "./details-news.vue?vue&type=script&lang=js"
import style0 from "./details-news.vue?vue&type=style&index=0&id=36d51590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d51590",
  null
  
)

export default component.exports